import { render, staticRenderFns } from "./LocalAffiliationsCombo.vue?vue&type=template&id=1db0690d&scoped=true"
import script from "./LocalAffiliationsCombo.vue?vue&type=script&lang=js"
export * from "./LocalAffiliationsCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db0690d",
  null
  
)

export default component.exports